export default __webpack_public_path__ + "static/media/Express.e9d309de.png";